module.exports = __webpack_public_path__ + "static/img/thimg3.f718a0cd.png";